import React, { Component } from 'react'
import { Row, Col, Button, Popconfirm, Table } from 'antd'
import PropTypes from 'prop-types'
import { app, api, config } from "../../../app"
import utils from "../../../utils"

class NewsRecord extends Component {
    constructor (props) {
        super(props)
        this.state = {
            page: 1,
            total: 0,
        }
    }

    componentDidMount () {
        this._isMounted = true
        this.handleRecordData()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 记录数据
     * @returns {Promise<void>}
     */
    handleRecordData = async (page = 1) => {
        await this.setData({ page, data_loading: true })
        let params = {
            page,
            id: this.props.record_id,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        let { flag, data, msg, total } = await app.post(api.NewsOperateList, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        await this.setData({ dataList: utils.addArrayKey(data), data_loading: false, total: Number(total || 0) })
    }

    render () {
        let { dataList, data_loading, page, total } = this.state,
            columns = [
                {
                    title: '操作时间',
                    dataIndex: 'work_time',
                    key: 'work_time',
                    width: '15%'
                },
                {
                    title: '操作前',
                    dataIndex: 'work_before',
                    key: 'work_before',
                    width: '25%',
                    render: (_, { event, id }) => {
                        switch (event) {
                            case 'news_content':
                                return (<Button type="text" size="small" onClick={() => this.props.openDetail(id, '1')}>详情</Button>)
                            case 'news_img':
                                return _ ? (<img src={config.imgUrl + _} width="80" height="80"/>) : '已清除'
                            default:
                                return (<div style={{wordBreak: 'break-all'}}>{_ || '无'}</div>)
                        }
                    }
                },
                {
                    title: '操作后',
                    dataIndex: 'work_after',
                    key: 'work_after',
                    width: '25%',
                    render: (_, { event, id }) => {
                        switch (event) {
                            case 'news_content':
                                return (<Button type="text" size="small" onClick={() => this.props.openDetail(id, '2')}>详情</Button>)
                            case 'news_img':
                                return  _ ? (<img src={config.imgUrl + _} width="80" height="80"/>) : '已清除'
                            default:
                                return (<div style={{wordBreak: 'break-all'}}>{_ || '无'}</div>)
                        }
                    }
                },
                {
                    title: '操作类型',
                    dataIndex: 'update_type',
                    key: 'update_type',
                    width: '20%',
                    render(_, {work_status}) {
                        switch (work_status) {
                            case '1':
                                return '添加' + _
                            case '2':
                                return '编辑' + _
                            case '3':
                                return '删除' + _
                        }
                    }
                },
                {
                    title: '操作人',
                    dataIndex: 'work_indexno',
                    key: 'work_indexno',
                    width: '15%'
                },
            ]
        return (
            <div>
                <Table size="small"
                       className="table-odd-even-row"
                       bordered={true}
                       locale={app.tbLocale(data_loading)}
                       columns={columns}
                       dataSource={dataList}
                       loading={data_loading}
                       pagination={{
                           current: page,
                           total,
                           pageSize: 20,
                           showTotal: (t) => `总数量：${t}`,
                           onChange: this.handleRecordData
                       }}
                       scroll={{ y: 'calc(100% - 46px)' }}
                />
            </div>
        )
    }
}


NewsRecord.propTypes = {
    openDetail: PropTypes.func,
    record_id: PropTypes.any,
}

export default NewsRecord



// WEBPACK FOOTER //
// ./src/routes/ranks/News/NewsRecord.jsx